"use client";
import className from "classnames/bind";
import { forwardRef, useEffect, useMemo, useState } from "react";
import { RhLink } from "@components";
import { replaceStringVar } from "@/core/utils";
import { useBusinessHours } from "@/providers/BusinessHoursContext";

import styles from "./Hero.module.scss";
import { usePageWrapperData } from "@/providers/PageWrapperContext";
const cx = className.bind(styles);

const HeroHours = forwardRef<HTMLDivElement>((_props, ref) => {
  const [isMounted, setIsMounted] = useState(false);

  const businessHours = useBusinessHours();
  const { labels, siteSettings: settings } = usePageWrapperData();
  const hoursLabels = labels?.hoursLabels;

  const openLabel = useMemo(() => {
    if (!hoursLabels) return '';
    if (businessHours.currentlyOpen) return hoursLabels.openLabel;
    if (businessHours.beforeBusinessHours) return hoursLabels.openingSoon;
    return hoursLabels.closedLabel;
  }, [businessHours, businessHours.currentDateTime, hoursLabels]);

  const hoursLabel = useMemo(() => {
    if (!hoursLabels || !businessHours.todaysHours) return '';
    if (businessHours.currentlyOpen) return replaceStringVar(hoursLabels.until, { time: businessHours.todaysHours.closeTimeLabel });
    if (businessHours.beforeBusinessHours) return replaceStringVar(hoursLabels.at, { time: businessHours.todaysHours.openTimeLabel });
    if (businessHours.openToday && !businessHours.afterBusinessHours) return replaceStringVar(hoursLabels.until, { time: businessHours.todaysHours.openTimeLabel });
    if (!businessHours.currentlyOpen && businessHours.openTomorrow) return replaceStringVar(hoursLabels.until, { time: businessHours.nextOpenHours.openTimeLabel });
    return replaceStringVar(hoursLabels.opensOnDate, { time: businessHours.nextOpenHours.openTimeLabel, date: businessHours.nextOpenHours.startDateLabel || '' });
  }, [businessHours, businessHours.currentDateTime]);
  useEffect(() => { setIsMounted(true); }, []); 
  // To avoid hydration mismatch component relies on user data, only render after mount
  if (!isMounted) return null;
  return (
    <div className={cx("hours-address")} ref={ref}>
      <div className={cx("column")}>
        {/* <RhLink aria-label={`${openLabel} ${hoursLabel}`} className={cx(["copy", "eyebrow-l"])} href="/">
          {openLabel}
        </RhLink> */}
        <p className={cx(["copy", "eyebrow-l"])} style={{ padding: '1rem' }}>
          {openLabel}
        </p>
        <p aria-hidden="true" className="eyebrow-l">{hoursLabel}</p>
      </div>
      <div className={cx("column")}>
        {settings?.address.addressLines.map((line, index) =>
          index === 0 ? (
            <a
              key={index}
              target="_blank"
              className={cx(["copy", "eyebrow-l"])}
              href={settings?.address.mapLink}
            >
              {line.line}
            </a>
          ) : (
            <p key={index} className="eyebrow-l">
              {line.line}
            </p>
          )
        )}
      </div>
    </div>
  );
});

export default HeroHours;